import React, { useContext, useState, useEffect } from "react";
import axios from "axios";
import { AuthContext } from "../../context/AuthContext";
import Loader from "../../components/Loader";
import { useQuery } from "@tanstack/react-query";
import Table from "../../components/Table";
import { Contractscolumns } from "../../components/headerContent";
import NumberCard from "../../components/Card/NumberCard";
import RowContract from "./RowContract";
import { useLocation, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faCircleCheck } from "@fortawesome/free-solid-svg-icons";

export default function Contract() {
  const { apiUrl, user } = useContext(AuthContext);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const contractId = searchParams.get("contractId");
  const referrer = searchParams.get("referrer");
  const [filteredData, setFilteredData] = useState([]);
  const { t } = useTranslation();

  const getContract = async () => {
    const res = await axios.get(`${apiUrl}contract/byserial`, {
      withCredentials: true,
    });
    if (res.data === "No data") {
      return [res.data];
    } else {
      return res.data.filter(item => !item.contract_number.includes("Contract"));
    }
  };

  const contract = useQuery({
    queryKey: ["contracts"],
    queryFn: getContract,
  });

  useEffect(() => {
    if (contract.data !== undefined && !contract.data.includes("No data")) {
      if (contractId) {
        const filteredData = contract.data.filter(cont => cont.contract_number === contractId);
        setFilteredData(filteredData);
      } else {
        setFilteredData(contract.data);
      }
    }
  }, [contract.data, contractId]);

  if (contract.data && contract.data.includes("No data") || contract.data && contract.data.length === 0) {
    return (
      <div className="ecp-container">
          <div className="ecp-container-content-error">
            <div className="error-container">
              <img src='../assets/ecp_error.svg' alt="icône d'erreur" />
              <div className="error-container-text">
                <h1 className="page-title">
                  {t("Aucun contrat disponible")}
                </h1>
                <p className="page-link_home">
                  <Link to="/"> {t("Revenir à l'accueil")}</Link>
                </p>
              </div>
            </div>
          </div>
        </div>
    );
  }

  const exportCSV = () => {
    axios.get(`${apiUrl}contract/export`, {
      withCredentials: true,
      responseType: 'blob'
    })
      .then((response) => {
        const blob = new Blob([response.data], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'contrats.csv';
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => { });
  };

  if (referrer) {
    contract.refetch();
  }


  if (contract.isLoading) {
    return <Loader />;
  }

  return (
    <div className="ecp-container">
      <div className="ecp-container-content">
        <div className="ecp-container-content-header">
          <div className="ecp-container-content-header-title">
            <div className="page-title page-logo">
              <img src="./assets/cisco_logo.png" alt="Logo de Cisco" />
              <h1 className="page-title">Smartnet</h1>
              {user.roles.includes("ROLE_SUPERADMIN") && <button className="buttons-ecp buttons-ecp-new" onClick={exportCSV}>{t('Exporter')}</button>}
            </div>
          </div>
        </div>
        <section className="page-section">
          <NumberCard
            title={t("Nombre de contrats disponibles")}
            number={
              filteredData.length
            }
            logo={faCircleCheck}
            color={"#AEC353"}
            stylesIcons={"logo-certificats"}
          />
        </section>
        {contractId && (
          <div className="page-title page-link-timeline">
            <Link to={`/${referrer}`} className="buttons-ecp button-new"><FontAwesomeIcon icon={faChevronLeft} /> {t('Retour')}</Link>
          </div>
        )}
        <div className='cato-content-table'>
          <Table
            tableData={
              filteredData
            }
            rowComponent={RowContract}
            tableColumns={Contractscolumns}
          />
        </div>
      </div>
    </div>
  );
}
